export function formatRelative(iso: string, now: Date = new Date()): string {
  const ts = new Date(iso).getTime();
  const diffSec = Math.floor((now.getTime() - ts) / 1000);
  if (diffSec < 60) return "hace menos de 1 min";
  if (diffSec < 3600) return `hace ${Math.floor(diffSec / 60)} min`;
  const hours = Math.floor(diffSec / 3600);
  return `hace ${hours} h`;
}
